import { timelineConfig } from './timeline-config';

export interface TimelineItemLayout {
    left: number;
    width: number;
}

export const calculateTimelineItemLayout = (startDate: Date, endDate: Date): TimelineItemLayout => {
    const secondsDiff = (endDate.getTime() - startDate.getTime()) / 1000;
    const secondsFromMidnight =
        3600 * startDate.getHours() + 60 * startDate.getMinutes() + startDate.getSeconds();

    const startPositionSeconds =
        secondsFromMidnight < timelineConfig.startTimeFromMidnight
            ? secondsFromMidnight +
              timelineConfig.secondsInFullDay -
              timelineConfig.startTimeFromMidnight
            : secondsFromMidnight - timelineConfig.startTimeFromMidnight;

    const left = Math.ceil(startPositionSeconds * timelineConfig.secondWidth);
    const width = Math.floor(secondsDiff * timelineConfig.secondWidth);

    return { left, width };
};
